import SkeletonBase from './SkeletonBase';

const SkeletonCircle = ({
  size = 40,
  className = '',
  style = {},
  variant,
  ...props
}) => {
  return (
    <SkeletonBase
      width={size}
      height={size}
      borderRadius="50%"
      className={`skeleton-circle ${className}`}
      style={{ flexShrink: 0, ...style }}
      variant={variant}
      {...props}
    />
  );
};

export default SkeletonCircle;
